<script setup>
  import {onBeforeMount, reactive, ref} from "vue";

  import {MedSpinner} from "@pharma4u/medicheck-components";
  import {coreRouter} from "@utils/coreRouter/coreRouter.js";

  defineOptions({
    name: "ComponentCoreInfoDialogText",
  });

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
    dialogType: {
      type: String,
      default: "",
    },
  });

  const text = ref("");
  const isLoading = ref(true);
  const coreLegacyDetailsData = reactive({
    dosage: {
      errorMessage: "Kein Text gefunden.",
      key: props.data?.key,
    },
    fi: {
      errorMessage: "Keine Dokumente gefunden.",
      key: props.data?.abdata_key_fam,
    },
    interaction: {
      errorMessage: "Kein Text gefunden.",
      key: props.data?.key,
    },
    guideline: {
      errorMessage: "Kein Text gefunden.",
      key: props.data?.key,
      medicationType: props.data?.medicationType,
    },
  });

  onBeforeMount(() => {
    loadMedicalInfoText();
  });

  const loadMedicalInfoText = () => {
    switch (props.dialogType) {
      case "dosage":
      case "fi":
      case "interaction":
      case "guideline":
        if (props.data?.url) loadContentFromUrl(props.data.url);
        else loadLegacyContentFromUrl();
        break;
      case "splitable":
      case "suspendability":
      case "mortarability":
      case "gender-specific":
      case "allergies-symptoms":
      case "criticalcombination":
        loadContentFromUrl(props.data.url);
        break;
    }
  };

  const loadContentFromUrl = (url) => {
    coreRouter.get(url, {
      onSuccess: (response) => {
        if (response) {
          isLoading.value = false;
          text.value = new DOMParser().parseFromString(response, "text/html").querySelector("main").innerHTML;
        }
      },
      onError: () => {
        isLoading.value = false;
        text.value = coreLegacyDetailsData[props.dialogType].errorMessage ?? "Keine Inhalte gefunden.";
      },
    });
  };

  const loadLegacyContentFromUrl = () => {
    coreRouter.loadDetailsFromLegacyLinks(props.dialogType, coreLegacyDetailsData[props.dialogType].key, {
      onSuccess: (response) => {
        isLoading.value = false;
        text.value = new DOMParser().parseFromString(response, "text/html").querySelector("main").innerHTML;
      },
      onError: () => {
        isLoading.value = false;
        text.value = coreLegacyDetailsData[props.dialogType].errorMessage ?? "Keine Inhalte gefunden.";
      },
    });
  };
</script>

<template>
  <div v-if="isLoading" class="flex flex-col items-center">
    <MedSpinner size="3xl" :data-test="getTestId('spinner')" />
  </div>

  <!-- eslint-disable-next-line vue/no-v-html -- renders the extracted <main> fragment of a Core service detail page (MC_CORE_URL); the payload is HTML markup by design -->
  <p v-else v-html="text" />
</template>
